import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { FilterModel, IServerSideGetRowsRequest } from 'ag-grid-community';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RestApiService {
  private http = inject(HttpClient);

  get<T>(url: string, extraOptions?: any): Observable<T> {
    const fullUrl = `${environment.endpoints.restApi}/${url}`;
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', ClientId: 'devinco' }),
    };
    if (extraOptions) {
      options = { ...options, ...extraOptions };
    }
    return this.http.get<T>(fullUrl, options);
  }

  post<TRes = any, TPayload = any>(
    urlEnd: string,
    data?: TPayload,
    extraOptions?: any,
  ): Observable<TRes> {
    const url = `${environment.endpoints.restApi}/${urlEnd}`;
    const body = JSON.stringify(data);
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', ClientId: 'devinco' }),
    };

    if (extraOptions) {
      options = { ...options, ...extraOptions };
    }
    return this.http.post<TRes>(url, body, options);
  }

  getRows<T>(request: GetRowsRequest): Observable<GetRowsResponse> {
    const url = `${environment.endpoints.restApi}/route/getRows`;
    const body = JSON.stringify(request);
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', ClientId: 'devinco' }),
    };
    return this.http.post<GetRowsResponse<T>>(url, body, options);
  }
}

export interface GetRowsRequest<T = any> extends Partial<IServerSideGetRowsRequest> {
  entity: string;
  fields: (keyof T)[];
  filterModel?: FilterModel;
  quickFilterText?: string;
  /** used for custom filtering that's not in ag-grid's api scope (trips grid) */
  customFilter?: object;
  /** array of required field names to get sum calculations from BE */
  sum?: string[];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface GetRowsResponse<TData = any> {
  data: TData;
  totalCount: number;
  /** object of fields with sum values that were requested in GetRowsRequest */
  sum?: object;
}
